<template>
  <div>
    <div class="container-header">
      <div class="titulo">Plataforma Inventario de Riesgos HSE - Online</div>
      <img src="../assets/images/BHP.png" class="logo" />
    </div>
    <div class="login-container">
      {{
        currentRouteName === "recoveryPassword0"
          ? "RECUPERACIÓN DE CONTRASEÑA"
          : ( currentRouteName === "autoCreacionStep0" ? "SESIÓN DE CREACIÓN DE UN NUEVO SERVICIO O CONTRATO (INVENTARIO) CONTRATISTA O INVENTARIO PROPIO DE COMPAÑÍA." : "") 
      }}
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
};
</script>

<style>
.login-container {
  padding-top: 13px;
  padding-left: 10px;
  color: white;
  font-weight: bold;
  height: 30px;
  background-color: #e85100;
  background-image: url(../assets/4634daf.jpeg);
  background-repeat: repeat;
}
a {
  color: transparent;
  text-decoration: none;
}
.container-header {
  background-color: #000000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  height: 70px;
}
.salir {
  margin-right: 20px;
}
.titulo {
  font-family: "Open Sans", sans-serif;
  font-size: 25px;
  font-weight: 500;
  color: white;
}
.logo {
  margin: 22px 10px;
  width: 100px;
}
</style>
